<template>
  <div class="account-status-text" :class="[calCssClass]">
    {{ calContent }}
  </div>
</template>

<script>
import { ACCOUNT_STATUS_REV, ACCOUNT_STATUS, PAYMENT_STATUS, PAYMENT_STATUS_REV } from '@/constants/propTrade';

export default {
  name: 'AccountStatus',
  props: {
    accountStatus: {
      type: String | Number,
      default: ''
    },
    type: {
      type: String,
      default: 'account' // account, paymentStatus
    }
  },
  data() {
    return {
      ACCOUNT_STATUS,
      ACCOUNT_STATUS_REV,
      PAYMENT_STATUS,
      PAYMENT_STATUS_REV
    };
  },
  computed: {
    calType() {
      return this.type;
    },
    ACCOUNT_STATUS_REVERSE() {
      const res = {};
      Object.keys(ACCOUNT_STATUS).forEach(item => {
        if (item !== null) {
          const value = ACCOUNT_STATUS[item];
          res[value] = item.toLowerCase();
        }
      });
      return res;
    },
    PAYMENT_STATUS_REVERSE() {
      const res = {};
      Object.keys(PAYMENT_STATUS).forEach(item => {
        if (item !== null) {
          const value = PAYMENT_STATUS[item];
          res[value] = item.toLowerCase();
        }
      });
      return res;
    },
    calAccountStatus() {
      return this.accountStatus;
    },
    calCssClass() {
      return this.calType === 'account'
        ? this.ACCOUNT_STATUS_REVERSE[this.calAccountStatus]
        : this.PAYMENT_STATUS_REVERSE[this.calAccountStatus];
    },
    calContent() {
      let accountContent = this.$t(this.ACCOUNT_STATUS_REV[this.calAccountStatus]);
      let paymentStatusContent = this.$t(this.PAYMENT_STATUS_REV[this.calAccountStatus]);
      return this.calType === 'account' ? accountContent : paymentStatusContent;
    }
  }
};
</script>

<style lang="scss" scoped>
.account-status-text {
  width: fit-content;
  font-weight: 500;
  font-size: 12px;
  color: #006bff;
  padding: 4px;
  white-space: nowrap;

  &.active,
  &.verifying,
  &.passed,
  &.processing,
  &.payout_pending {
    color: #006bff;
  }
  &.failed {
    color: #ed3434;
  }
}
</style>
